import { render, staticRenderFns } from "./myOrderInfo.vue?vue&type=template&id=4f839ac3&scoped=true&"
import script from "./myOrderInfo.vue?vue&type=script&lang=js&"
export * from "./myOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./myOrderInfo.vue?vue&type=style&index=0&id=4f839ac3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f839ac3",
  null
  
)

export default component.exports